// Iframeをモーダルウィンドウで表示
// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
function modalIframe(name) {
  const id = `#${name}-iframe`;
  const link = $(id).text();
  $(id).html(`<iframe src="${link}">`);
}

global.modalIframe = modalIframe;
